import { useEffect, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { getDecodedHtml } from "utils/getDecodedHtml";
import { headerGA4Props } from "./types/public-header-types";

const HeaderDropdownListItem = ({
	className = "",
	data,
	isFirstInGroup = false,
	isLastInGroup = false,
	isGroupedItem = false,
	toggleActiveMain,
	parent,
	qaAttr
}) => {
	const { label, url, isExternalLink, type } = data;

	const [isActive, setIsActive] = useState("");

	const toggleActive = useCallback((url, toggleActiveMain) => {
		const currentLinkArray = url.split("/");
		const currentLinkItem = currentLinkArray[currentLinkArray.length - 1];
		const currentPage = window.location.pathname.split("/");

		if (currentPage !== undefined) {
			currentPage.forEach((currentPageItem) => {
				if (currentPageItem !== "" && currentLinkItem === currentPageItem) {
					setIsActive(" active ");
					if (toggleActiveMain) {
						toggleActiveMain(" active ");
					}
				} else {
					setIsActive("");
				}
			});
		} else {
			setIsActive("");
		}
	}, []);

	useEffect(() => {
		toggleActive(url, toggleActiveMain);
	}, [url, toggleActive, toggleActiveMain]);

	switch (type) {
		case "link":
			return (
				<li
					className={`${isGroupedItem ? "nav-dropdown-grouped-item" : "nav-dropdown-item"} ${
						isFirstInGroup ? "nav-dropdown-grouped-item-first" : ""
					} ${isLastInGroup ? "nav-dropdown-grouped-item-last" : ""} ${isActive} ${className} `}
				>
					<a
						href={url}
						target={isExternalLink ? "_blank" : "_self"}
						aria-label={getDecodedHtml(label)}
						data-a="true"
						data-a-lbl={getDecodedHtml(label)}
						data-a-cat="Navigation"
						data-a-act="Header"
						data-a-evt={headerGA4Props["data-a-evt"]}
						data-a-loc={headerGA4Props["data-a-loc"]}
						data-a-subloc={parent}
						data-a-text={getDecodedHtml(label)}
						data-a-comp={headerGA4Props["data-a-comp"]}
						data-qa={getDecodedHtml(qaAttr)}
						dangerouslySetInnerHTML={{ __html: getDecodedHtml(label) }}
						rel="noreferrer"
					/>
				</li>
			);
		case "group":
			return (
				<li
					className="nav-dropdown-group-label"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(label) }}
				/>
			);
		default:
			break;
	}
};

HeaderDropdownListItem.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		url: PropTypes.string,
		label: PropTypes.string,
		isExternalLink: PropTypes.bool
	}),
	isFirstInGroup: PropTypes.bool,
	isLastInGroup: PropTypes.bool,
	isGroupedItem: PropTypes.bool,
	toggleActiveMain: PropTypes.func,
	parent: PropTypes.string,
	qaAttr: PropTypes.string
};

export default HeaderDropdownListItem;
